import { Stack } from "@mui/material";
import { useEffect, useState } from "react";

import SearchBar from "./components/SearchBar";
import { SearchRequest, useSearchCustomer } from "../../api/customer";
import CustomerDataGrid from "../../components/customer360/customerDataGrid/CustomerDataGrid";
import {
  useCustomerStore,
  useSetCustomerStore,
} from "../../stores/customerStore";
import { usePermissionStore } from "../../stores/permissionStore";

const Customer360 = () => {
  const [isSearch, setIsSearch] = useState(false);
  const customerStore = useCustomerStore();
  const setCustomerStore = useSetCustomerStore();

  const [request, setRequest] = useState<SearchRequest>({
    pagination: {
      currentPage: 1,
      pageSize: 12,
    },
    permission_Token: usePermissionStore.getState().permissionToken ?? "",
  });

  const { data: dataCustomer, isFetching } = useSearchCustomer(
    request,
    isSearch,
  );

  useEffect(() => {
    if (dataCustomer) {
      setCustomerStore(dataCustomer.data);
    }
  }, [dataCustomer]);

  return (
    <Stack paddingX={4}>
      <SearchBar
        request={request}
        setRequest={setRequest}
        setIsSearch={setIsSearch}
      />
      <CustomerDataGrid
        onPageChange={page => {
          setRequest({
            ...request,
            pagination: { ...request.pagination, currentPage: page },
          });
        }}
        data={customerStore}
        loading={isFetching}
      />
    </Stack>
  );
};

export default Customer360;
